import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import logo from "../../assets/images/logo-no-background-big.png";

const MobileHeader = ({ isOpen, closeMobileHeader, tabs, activeTab }) => {
  const { t, i18n } = useTranslation();
  const languages = ["bg", "en", "de", "ro"];
  const currentLang = (i18n.language || "bg").slice(0, 2);
  const getTabPath = (tab) => (tab === "home" ? "/" : `/${tab}`);

  function onMenuItemClick() {
    window.scrollTo(10, 0);
    closeMobileHeader();
  }

  return (
    <div className={`mobile-menu${isOpen ? " mobile-menu--open" : ""}`}>
      <div
        className="menu-backdrop"
        onClick={closeMobileHeader}
        aria-hidden="true"
      />
      <nav className="menu-box" aria-label="Mobile navigation">
        <button
          type="button"
          className="close-btn"
          onClick={closeMobileHeader}
          aria-label="Close menu"
        >
          <i className="icon far fa-times" />
        </button>

        <div className="nav-logo">
          <Link to="/" onClick={onMenuItemClick}>
            <img src={logo} alt="Hotel Admiral" />
          </Link>
        </div>

        <div className="menu-outer">
          <ul className="navigation mobile-navigation">
            {tabs.map((tab) => (
              <li key={tab}>
                <Link
                  to={getTabPath(tab)}
                  onClick={onMenuItemClick}
                  className={activeTab === tab ? "navigation-active-tab" : ""}
                >
                  {t(tab === "rooms" ? "accommodation" : tab)}
                </Link>
              </li>
            ))}
          </ul>

          <div className="mobile-language-change">
            {languages.map((lang) => (
              <button
                type="button"
                className={`mobile-language-change__lang ${
                  currentLang === lang ? "mobile-language-change__lang-selected" : ""
                }`}
                key={lang}
                onClick={() => {
                  i18n.changeLanguage(lang);
                  localStorage.setItem("hotel-admiral-language", lang);
                }}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default MobileHeader;
